'use client'

import { useEffect, useRef } from 'react'
import { trackStoreEvent, StoreAnalytics, PageLocation } from '@nile/mantine-theme/analytics'

interface ProductDetailPageViewedTrackerProps {
    skuId: number
    skuName: string
}

/** Fires the storefront funnel detail-page view once per SKU on the medication PDP. */
export function ProductDetailPageViewedTracker({ skuId, skuName }: ProductDetailPageViewedTrackerProps) {
    const trackedSkuIds = useRef<Set<number>>(new Set())

    useEffect(() => {
        if (!skuId || trackedSkuIds.current.has(skuId)) return
        trackedSkuIds.current.add(skuId)

        trackStoreEvent(StoreAnalytics.VIEWED_DETAIL_PAGE, {
            location: PageLocation.DETAIL_PAGE,
            sku_id: skuId,
            sku_name: skuName,
        })
    }, [skuId, skuName])

    return null
}
